import { render, staticRenderFns } from "./studymaterial.vue?vue&type=template&id=517eb75b&"
import script from "./studymaterial.vue?vue&type=script&lang=js&"
export * from "./studymaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports